export default "__VITE_ASSET__BRDs$d3A__"